// src/utils/downloadAllToLocal.js

import { getDocs, collection } from 'firebase/firestore';
import { db as firebaseDB } from '../firebase';
import dexie from '../offlineDB'; // this should match your Dexie file
import { getAuth } from 'firebase/auth';


export async function downloadAllToLocal() {
  const user = getAuth().currentUser;
  if (!user) return alert("You must be logged in");

  const uid = user.uid;

  try {
    // Tunes
    const tuneSnap = await getDocs(collection(firebaseDB, 'users', uid, 'tunes'));
    const tunes = tuneSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    await dexie.tunes.bulkPut(tunes);

    // Sets
    const setSnap = await getDocs(collection(firebaseDB, 'users', uid, 'sets'));
    const sets = setSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    await dexie.sets.bulkPut(sets);

    // Sessions
    const sessSnap = await getDocs(collection(firebaseDB, 'users', uid, 'sessions'));
    const sessions = sessSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    await dexie.sessions.bulkPut(sessions);

    alert("All data saved for offline use!");
  } catch (err) {
    console.error("Download failed", err);
    alert("Error downloading data. Check console.");
  }
}
